import React from "react";
import styled from "styled-components";
import { ZIndexes, background, content, cover, size } from "@glossy";
import logo from "./logo.svg?raw";

const Root = styled.div`
  ${cover()};
  display: flex;
  z-index: ${ZIndexes.Panel};
  background-color: ${background};
  color: ${content};
  align-items: center;
  justify-content: center;
  svg {
    opacity: 0.5;
    ${size(46)};
  }
`;

const UiKitSplashScreen = () => (
  <Root dangerouslySetInnerHTML={{ __html: logo }} />
);

export default UiKitSplashScreen;
